// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__s3fio","expTitle":"Modal_expTitle__QRim1","listSkills":"Modal_listSkills__m+X3x","techLinks":"Modal_techLinks__hIEne","techColor":"Modal_techColor__I8EdY"};